module.exports = __webpack_public_path__ + "static/media/feature-clock.987b80d7.svg";